import Model from '../Model'
import moment from "moment/moment";
import {toFormData} from "../../utils";

export default class NonConformanceReport extends Model {
    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.date).format('DD/MM/YYYY');
        let tokens = [
            'NCR', this.formattedDate, this.title, this.reference, this.packageReference, this.packageName
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    static parseAttributes(attributes = {}) {
        attributes.package = attributes.package?.value
        return attributes
    }

    getFormAttributes() {
        return this.only(['id', 'title', 'date', 'contractReference', 'locationOfWorks', 'siteAddress', 'whatWentWrong', 'whyNotMeetingSpec', 'whatToPrevent', 'correctiveActionTaken', 'keyPlayers'])
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.hsqe.non-conformance-reports', {
            package_reference: packageReference,
            id
        }), {})
        return this.make(data)
    }

    static async all(packageReference = null) {
        const data = await Http.get(route('api.v2.hsqe.non-conformance-reports.list', [packageReference]))
        return this.make(data)
    }

    static async allOpened() {
        const params = {status: 'Open'}
        const {data} = await Http.get(route('api.v2.hsqe.non-conformance-reports'), {params})
        return this.make(data)
    }

    static async create(packageReference, attributes) {
        const url = route('api.v2.hsqe.non-conformance-reports.store', [packageReference, attributes.id])
        let payload = this.parseAttributes(attributes);
        const o = await Http.post(url, toFormData(payload))
        return await this.find(packageReference, attributes.id)
    }

    getNotesUrl() {
        return route('api.v2.hsqe.non-conformance-reports.notes.list', {
            package_reference: this.packageReference,
            id: this.id
        });
    }

    postNotesUrl() {
        return route('api.v2.hsqe.non-conformance-reports.notes.store', {
            package_reference: this.packageReference,
            id: this.id
        });
    }

    async update(attributes = {}) {
        const url = route('api.v2.hsqe.non-conformance-reports.store', {
            package_reference: this.packageReference,
            id: this.id
        })
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const o = await Http.put(url, toFormData(payload))
    }

    async reload() {
        const data = await NonConformanceReport.find(this.packageReference, this.id)
        Object.assign(this, data)
    }

    async delete() {
        await Http.delete(route('api.v2.hsqe.non-conformance-reports.delete', {
            package_reference: this.packageReference,
            id: this.id
        }))
    }

    async reopen() {
        await this.update({status: "Open"})
        await this.reload()
    }

    async close() {
        await this.update({status: "Closed"})
        await this.reload()
    }

    async send(attributes = {}) {
        const url = route('api.v2.hsqe.non-conformance-reports.send', [this.packageReference, this.id])
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.non-conformance-reports', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async revoke(sendRequestId) {
        const url = route('api.v2.hsqe.non-conformance-reports.revoke', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.non-conformance-reports', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.hsqe.non-conformance-reports.resend', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.non-conformance-reports', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }
}
